var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-right-cmp"},[_c('div',{staticClass:"chart-name"},[_vm._v(" 设备运行效率 "),_c('dv-decoration-3',{staticStyle:{"width":"200px","height":"20px"}})],1),_c('dv-charts',{attrs:{"option":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }